export default __webpack_public_path__ + "static/media/head04_vi_pc@2x.02c76a8b.png";